<template>
  <el-container class="agent-shell" :class="{ 'mobile-chat-mode': mobileChatMode }">
    <el-header v-show="!mobileChatMode" class="agent-header">
      <span>客服工作台</span>
      <el-button type="text" class="logout-btn" @click="logout">退出</el-button>
    </el-header>
    <el-main class="agent-main"><router-view @mobile-chat-change="onMobileChatChange" /></el-main>
  </el-container>
</template>

<script>
import { clearToken } from '../utils/auth';

export default {
  data() {
    return {
      mobileChatMode: false
    };
  },
  methods: {
    logout() {
      clearToken();
      this.$router.replace('/login');
    },
    onMobileChatChange(inChat) {
      this.mobileChatMode = !!inChat;
    }
  }
};
</script>

<style scoped>
.agent-shell {
  min-height: 100vh;
  background: #f5f7fa;
}

.agent-header {
  background: #409eff;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px !important;
  line-height: 56px;
  padding: 0 16px;
}

.logout-btn {
  color: #fff !important;
}

.agent-main {
  padding: 16px;
}

@media (max-width: 768px) {
  .agent-main {
    padding: 0;
  }

  .agent-shell.mobile-chat-mode .agent-main {
    padding: 0;
  }
}
</style>
